"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseInput = exports.BaseInputWrapper = void 0;
var react_1 = __importDefault(require("react"));
var Box_1 = require("../Box");
var core_1 = require("../core");
exports.BaseInputWrapper = core_1.styled(Box_1.Box, {
    'cursor': 'text',
    'overflow': 'hidden',
    'backgroundColor': '$white',
    '&:focus-within': {
        border: '1px solid colors.$focus',
    },
}, {
    size: core_1.mapTokens('fontSizes', function (value, name) { return ({ fontSize: value, lineHeight: name }); }),
});
exports.BaseInputWrapper.defaultProps = {
    border: '$grey4',
    borderRadius: '$4px',
    size: '$14px',
    space: '$8px',
};
exports.BaseInput = react_1.default.forwardRef(function BaseInput(_a, ref) {
    var onChange = _a.onChange, placeholder = _a.placeholder, _b = _a.type, type = _b === void 0 ? 'text' : _b, value = _a.value;
    return (react_1.default.createElement(StyledInput, { ref: ref, onChange: function (event) { return onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value); }, placeholder: placeholder, type: type, value: value }));
});
var StyledInput = core_1.styled('input', {
    'border': 'none',
    'cursor': 'inherit',
    'fontSize': 'inherit',
    'lineHeight': 'inherit',
    '&:focus': {
        outline: 'none',
    },
});
